require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.misc.refs.js");
goog.provide('com.wsscode.misc.refs');
/**
 * Clojure/Clojurescript efficient keyword comparison.
 */

com.wsscode.misc.refs.kw_identical_QMARK_ = function com$wsscode$misc$refs$kw_identical_QMARK_(kw_a, kw_b) {
  return cljs.core.keyword_identical_QMARK_(kw_a, kw_b);
};
/**
 * Check if x is an atom.
 */


com.wsscode.misc.refs.atom_QMARK_ = function com$wsscode$misc$refs$atom_QMARK_(x) {
  if (!(x == null)) {
    if (x.cljs$lang$protocol_mask$partition0$ & 32768 || cljs.core.PROTOCOL_SENTINEL === x.cljs$core$IDeref$) {
      return true;
    } else {
      if (!x.cljs$lang$protocol_mask$partition0$) {
        return cljs.core.native_satisfies_QMARK_(cljs.core.IDeref, x);
      } else {
        return false;
      }
    }
  } else {
    return cljs.core.native_satisfies_QMARK_(cljs.core.IDeref, x);
  }
};
/**
 * @interface
 */


com.wsscode.misc.refs.GenericBox = function () {};

var com$wsscode$misc$refs$GenericBox$_greset_BANG_$dyn_33199 = function com$wsscode$misc$refs$GenericBox$_greset_BANG_$dyn_33199(this$, value) {
  var x__4428__auto__ = this$ == null ? null : this$;

  var m__4429__auto__ = com.wsscode.misc.refs._greset_BANG_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(this$, value) : m__4429__auto__.call(null, this$, value);
  } else {
    var m__4426__auto__ = com.wsscode.misc.refs._greset_BANG_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(this$, value) : m__4426__auto__.call(null, this$, value);
    } else {
      throw cljs.core.missing_protocol("GenericBox.-greset!", this$);
    }
  }
};

com.wsscode.misc.refs._greset_BANG_ = function com$wsscode$misc$refs$_greset_BANG_(this$, value) {
  if (!(this$ == null) && !(this$.com$wsscode$misc$refs$GenericBox$_greset_BANG_$arity$2 == null)) {
    return this$.com$wsscode$misc$refs$GenericBox$_greset_BANG_$arity$2(this$, value);
  } else {
    return com$wsscode$misc$refs$GenericBox$_greset_BANG_$dyn_33199(this$, value);
  }
};

var com$wsscode$misc$refs$GenericBox$_gswap_BANG_$dyn_33200 = function () {
  var G__33201 = null;

  var G__33201__2 = function G__33201__2(this$, f) {
    var x__4428__auto__ = this$ == null ? null : this$;

    var m__4429__auto__ = com.wsscode.misc.refs._gswap_BANG_[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(this$, f) : m__4429__auto__.call(null, this$, f);
    } else {
      var m__4426__auto__ = com.wsscode.misc.refs._gswap_BANG_["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(this$, f) : m__4426__auto__.call(null, this$, f);
      } else {
        throw cljs.core.missing_protocol("GenericBox.-gswap!", this$);
      }
    }
  };

  var G__33201__3 = function G__33201__3(this$, f, x) {
    var x__4428__auto__ = this$ == null ? null : this$;

    var m__4429__auto__ = com.wsscode.misc.refs._gswap_BANG_[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(this$, f, x) : m__4429__auto__.call(null, this$, f, x);
    } else {
      var m__4426__auto__ = com.wsscode.misc.refs._gswap_BANG_["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(this$, f, x) : m__4426__auto__.call(null, this$, f, x);
      } else {
        throw cljs.core.missing_protocol("GenericBox.-gswap!", this$);
      }
    }
  };

  var G__33201__4 = function G__33201__4(this$, f, x, y) {
    var x__4428__auto__ = this$ == null ? null : this$;

    var m__4429__auto__ = com.wsscode.misc.refs._gswap_BANG_[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$4 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$4(this$, f, x, y) : m__4429__auto__.call(null, this$, f, x, y);
    } else {
      var m__4426__auto__ = com.wsscode.misc.refs._gswap_BANG_["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$4 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$4(this$, f, x, y) : m__4426__auto__.call(null, this$, f, x, y);
      } else {
        throw cljs.core.missing_protocol("GenericBox.-gswap!", this$);
      }
    }
  };

  var G__33201__5 = function G__33201__5(this$, f, x, y, more) {
    var x__4428__auto__ = this$ == null ? null : this$;

    var m__4429__auto__ = com.wsscode.misc.refs._gswap_BANG_[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$5 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$5(this$, f, x, y, more) : m__4429__auto__.call(null, this$, f, x, y, more);
    } else {
      var m__4426__auto__ = com.wsscode.misc.refs._gswap_BANG_["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$5 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$5(this$, f, x, y, more) : m__4426__auto__.call(null, this$, f, x, y, more);
      } else {
        throw cljs.core.missing_protocol("GenericBox.-gswap!", this$);
      }
    }
  };

  G__33201 = function G__33201(this$, f, x, y, more) {
    switch (arguments.length) {
      case 2:
        return G__33201__2.call(this, this$, f);

      case 3:
        return G__33201__3.call(this, this$, f, x);

      case 4:
        return G__33201__4.call(this, this$, f, x, y);

      case 5:
        return G__33201__5.call(this, this$, f, x, y, more);
    }

    throw new Error('Invalid arity: ' + arguments.length);
  };

  G__33201.cljs$core$IFn$_invoke$arity$2 = G__33201__2;
  G__33201.cljs$core$IFn$_invoke$arity$3 = G__33201__3;
  G__33201.cljs$core$IFn$_invoke$arity$4 = G__33201__4;
  G__33201.cljs$core$IFn$_invoke$arity$5 = G__33201__5;
  return G__33201;
}();

com.wsscode.misc.refs._gswap_BANG_ = function com$wsscode$misc$refs$_gswap_BANG_(var_args) {
  var G__33185 = arguments.length;

  switch (G__33185) {
    case 2:
      return com.wsscode.misc.refs._gswap_BANG_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return com.wsscode.misc.refs._gswap_BANG_.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return com.wsscode.misc.refs._gswap_BANG_.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    case 5:
      return com.wsscode.misc.refs._gswap_BANG_.cljs$core$IFn$_invoke$arity$5(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.misc.refs._gswap_BANG_.cljs$core$IFn$_invoke$arity$2 = function (this$, f) {
  if (!(this$ == null) && !(this$.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$2 == null)) {
    return this$.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$2(this$, f);
  } else {
    return com$wsscode$misc$refs$GenericBox$_gswap_BANG_$dyn_33200(this$, f);
  }
};

com.wsscode.misc.refs._gswap_BANG_.cljs$core$IFn$_invoke$arity$3 = function (this$, f, x) {
  if (!(this$ == null) && !(this$.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$3 == null)) {
    return this$.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$3(this$, f, x);
  } else {
    return com$wsscode$misc$refs$GenericBox$_gswap_BANG_$dyn_33200(this$, f, x);
  }
};

com.wsscode.misc.refs._gswap_BANG_.cljs$core$IFn$_invoke$arity$4 = function (this$, f, x, y) {
  if (!(this$ == null) && !(this$.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$4 == null)) {
    return this$.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$4(this$, f, x, y);
  } else {
    return com$wsscode$misc$refs$GenericBox$_gswap_BANG_$dyn_33200(this$, f, x, y);
  }
};

com.wsscode.misc.refs._gswap_BANG_.cljs$core$IFn$_invoke$arity$5 = function (this$, f, x, y, more) {
  if (!(this$ == null) && !(this$.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$5 == null)) {
    return this$.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$5(this$, f, x, y, more);
  } else {
    return com$wsscode$misc$refs$GenericBox$_gswap_BANG_$dyn_33200(this$, f, x, y, more);
  }
};

com.wsscode.misc.refs._gswap_BANG_.cljs$lang$maxFixedArity = 5;
cljs.core.Atom.prototype.com$wsscode$misc$refs$GenericBox$ = cljs.core.PROTOCOL_SENTINEL;

cljs.core.Atom.prototype.com$wsscode$misc$refs$GenericBox$_greset_BANG_$arity$2 = function (this$, value) {
  var this$__$1 = this;
  return cljs.core.reset_BANG_(this$__$1, value);
};

cljs.core.Atom.prototype.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$2 = function (this$, f) {
  var this$__$1 = this;
  return cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$2(this$__$1, f);
};

cljs.core.Atom.prototype.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$3 = function (this$, f, x) {
  var this$__$1 = this;
  return cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$3(this$__$1, f, x);
};

cljs.core.Atom.prototype.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$4 = function (this$, f, x, y) {
  var this$__$1 = this;
  return cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$4(this$__$1, f, x, y);
};

cljs.core.Atom.prototype.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$5 = function (this$, f, x, y, more) {
  var this$__$1 = this;
  return cljs.core.apply.cljs$core$IFn$_invoke$arity$variadic(cljs.core.swap_BANG_, this$__$1, f, x, y, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([more], 0));
};

cljs.core.Volatile.prototype.com$wsscode$misc$refs$GenericBox$ = cljs.core.PROTOCOL_SENTINEL;

cljs.core.Volatile.prototype.com$wsscode$misc$refs$GenericBox$_greset_BANG_$arity$2 = function (this$, value) {
  var this$__$1 = this;
  return cljs.core.vreset_BANG_(this$__$1, value);
};

cljs.core.Volatile.prototype.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$2 = function (this$, f) {
  var this$__$1 = this;
  return this$__$1.cljs$core$IVolatile$_vreset_BANG_$arity$2(null, function () {
    var G__33186 = this$__$1.cljs$core$IDeref$_deref$arity$1(null);
    return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(G__33186) : f.call(null, G__33186);
  }());
};

cljs.core.Volatile.prototype.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$3 = function (this$, f, x) {
  var this$__$1 = this;
  return this$__$1.cljs$core$IVolatile$_vreset_BANG_$arity$2(null, function () {
    var G__33187 = this$__$1.cljs$core$IDeref$_deref$arity$1(null);
    var G__33188 = x;
    return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(G__33187, G__33188) : f.call(null, G__33187, G__33188);
  }());
};

cljs.core.Volatile.prototype.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$4 = function (this$, f, x, y) {
  var this$__$1 = this;
  return this$__$1.cljs$core$IVolatile$_vreset_BANG_$arity$2(null, function () {
    var G__33189 = this$__$1.cljs$core$IDeref$_deref$arity$1(null);
    var G__33190 = x;
    var G__33191 = y;
    return f.cljs$core$IFn$_invoke$arity$3 ? f.cljs$core$IFn$_invoke$arity$3(G__33189, G__33190, G__33191) : f.call(null, G__33189, G__33190, G__33191);
  }());
};

cljs.core.Volatile.prototype.com$wsscode$misc$refs$GenericBox$_gswap_BANG_$arity$5 = function (this$, f, x, y, more) {
  var this$__$1 = this;
  return cljs.core.vreset_BANG_(this$__$1, cljs.core.apply.cljs$core$IFn$_invoke$arity$5(f, cljs.core.deref(this$__$1), x, y, more));
};

com.wsscode.misc.refs.greset_BANG_ = function com$wsscode$misc$refs$greset_BANG_(this$, val) {
  return com.wsscode.misc.refs._greset_BANG_(this$, val);
};

com.wsscode.misc.refs.gswap_BANG_ = function com$wsscode$misc$refs$gswap_BANG_(var_args) {
  var G__33198 = arguments.length;

  switch (G__33198) {
    case 2:
      return com.wsscode.misc.refs.gswap_BANG_.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return com.wsscode.misc.refs.gswap_BANG_.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return com.wsscode.misc.refs.gswap_BANG_.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___33204 = arguments.length;
      var i__4737__auto___33205 = 0;

      while (true) {
        if (i__4737__auto___33205 < len__4736__auto___33204) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___33205]);
          var G__33206 = i__4737__auto___33205 + 1;
          i__4737__auto___33205 = G__33206;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(4), 0, null);
      return com.wsscode.misc.refs.gswap_BANG_.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], arguments[2], arguments[3], argseq__4758__auto__);
  }
};

com.wsscode.misc.refs.gswap_BANG_.cljs$core$IFn$_invoke$arity$2 = function (this$, f) {
  return com.wsscode.misc.refs._gswap_BANG_(this$, f);
};

com.wsscode.misc.refs.gswap_BANG_.cljs$core$IFn$_invoke$arity$3 = function (this$, f, x) {
  return com.wsscode.misc.refs._gswap_BANG_(this$, f, x);
};

com.wsscode.misc.refs.gswap_BANG_.cljs$core$IFn$_invoke$arity$4 = function (this$, f, x, y) {
  return com.wsscode.misc.refs._gswap_BANG_(this$, f, x, y);
};

com.wsscode.misc.refs.gswap_BANG_.cljs$core$IFn$_invoke$arity$variadic = function (this$, f, x, y, more) {
  return com.wsscode.misc.refs._gswap_BANG_(this$, f, x, y, more);
};
/** @this {Function} */


com.wsscode.misc.refs.gswap_BANG_.cljs$lang$applyTo = function (seq33193) {
  var G__33194 = cljs.core.first(seq33193);
  var seq33193__$1 = cljs.core.next(seq33193);
  var G__33195 = cljs.core.first(seq33193__$1);
  var seq33193__$2 = cljs.core.next(seq33193__$1);
  var G__33196 = cljs.core.first(seq33193__$2);
  var seq33193__$3 = cljs.core.next(seq33193__$2);
  var G__33197 = cljs.core.first(seq33193__$3);
  var seq33193__$4 = cljs.core.next(seq33193__$3);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__33194, G__33195, G__33196, G__33197, seq33193__$4);
};

com.wsscode.misc.refs.gswap_BANG_.cljs$lang$maxFixedArity = 4;
Object.defineProperty(module.exports, "kw_identical_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.refs.kw_identical_QMARK_;
  }
});
Object.defineProperty(module.exports, "atom_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.refs.atom_QMARK_;
  }
});
Object.defineProperty(module.exports, "GenericBox", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.refs.GenericBox;
  }
});
Object.defineProperty(module.exports, "_greset_BANG_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.refs._greset_BANG_;
  }
});
Object.defineProperty(module.exports, "_gswap_BANG_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.refs._gswap_BANG_;
  }
});
Object.defineProperty(module.exports, "greset_BANG_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.refs.greset_BANG_;
  }
});
Object.defineProperty(module.exports, "gswap_BANG_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.misc.refs.gswap_BANG_;
  }
});